import { Modal, Row } from "react-bootstrap"
import Search from "components/Lessons/Search/Root"
import titleCase from "helpers/titleCase"
import { LessonResponse } from "shared/lessons"
import { StudentResponse } from "shared/types/teacherTypes"
import { AssessmentResponse } from "shared/routes/assessments/assessments"

interface Props {
    selectModal: string
    onHide: () => void
    onSelection: (lesson: LessonResponse, selectedStudent?: StudentResponse, assessment?: AssessmentResponse) => unknown
    includeUnlinkedAssessments?: boolean
}

const SelectModal = ({ selectModal, onHide, onSelection, includeUnlinkedAssessments } : Props) => {
  return (
    <Modal size="xl" show={!!selectModal} onHide={onHide}>
        <Modal.Header closeButton>
            Select {titleCase(selectModal)}
        </Modal.Header>

        <Modal.Body>
            <Row>
                <Search
                    onLessonSelection={onSelection}
                    viewType="landing"
                    includeUnlinkedAssessments={includeUnlinkedAssessments}
                />
            </Row>
        </Modal.Body>

        <Modal.Footer>
        </Modal.Footer>
    </Modal>
  )
}

export default SelectModal
